import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";

import { title, List } from "utils";

import { Header } from "components";
import { Button } from "antd";

class ProjectListPage extends Component {
  render() {
    const bread = [{ text: "Liste des projets" }];

    return (
      <Fragment>
        <Helmet>{title("Liste des projets")}</Helmet>

        <Header title="Projets" bread={bread} />

        <div className="projet-list-page main-content">
          <List cards={this.props.cards} type="projects" />
        </div>
      </Fragment>
    );
  }
}

export default ProjectListPage;
